<!--多级联动 选择分类-->
<template>
  <el-tree 
    ref="tree"
    class="classify-tree"
    :data="treeData" 
    :props="treeProps"
    :node-key="nodeKey"
    :highlight-current="true"
    :default-expanded-keys="computed_expandedKeysArr"
    :expand-on-click-node="false"
    @node-click="nodeClick"
  >
    <div slot-scope="{ node }" class="custom-tree-node">
      <img v-if="customIcon" class="iconfont icon-wenjianjia-gongkai" src="~@/assets/img/wenjianjia.png" style="margin-right: 6px;">
      <span class="custom-tree-node-title" :title="node.label">{{ node.label }}</span>
    </div>
  </el-tree>
</template>

<script>
export default {
  name: 'ClassifySelectV2',
  props: {
    treeData: {
      /**
       * id
       * name
       * parentId
       * weight
       * children
       * ...
       * 
       */
      type: Array,
      default: () => []
    },
    expandedKeys: {
      type: Array,
      default: () => []
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    treeProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'name'
        }
      }
    },
    customIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    computed_expandedKeysArr() {
      // 处理expandedKeys存在[null]的情况
      return [...new Set(this.expandedKeys.filter((item) => { return !!item }))]
    }, 
  },
  methods: {
    nodeClick(data) {
      this.$emit('tree-node-click', data)
    },
  },
}
</script>

<style lang='less' scoped>
.classify-tree {
  /deep/.el-tree-node__content {
    height: 32px;
    line-height: 32px;
    .custom-tree-node {
      width: calc(100% - 24px);
      display: flex;
      height: 32px;
      line-height: 32px;
      .custom-tree-node-title {
        // max-width: calc(100% - 103px);
        // margin-left: 3px;
        max-width: calc(100% - 84px);
        overflow: hidden;            // 溢出隐藏
        text-overflow: ellipsis;      // 溢出用省略号显示
        white-space: nowrap;         // 规定段落中的文本不进行换行
      }

      .icon-wenjianjia-gongkai {
        width: 16px;
        height: 16px;
        margin-top: 8px;
      }
    }
  }
}
</style>
